import * as React from "react";
import { UnpublishedProductEcommContent } from "./UnpublishedProductEcommContent.js";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
const UnpublishedProductEcommContentContainer = () => {
  const { activeVariant } = useProductData();
  const productColor = activeVariant.facets.color;
  return /* @__PURE__ */ React.createElement(UnpublishedProductEcommContent, { productColor });
};
export {
  UnpublishedProductEcommContentContainer
};
//# sourceMappingURL=UnpublishedProductEcommContentContainer.js.map
